import React from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { getPageUrl } from 'app/modules/shared/routing'
import { trackEvent } from 'app/modules/shared/helpers'
import AppbarDropdown from './appbar-dropdown'
import { getActiveSubRouteClass } from './helpers/helpers'

const DIGEST_ROUTE = 'digest'
const AETHER_ROUTE = 'upgrade-to-metadefender-aether'

// Commercial entry points (Digest, Aether upgrade) in one dropdown,
// kept apart from the community items.
const Enterprise = ({ hasReward }: { hasReward: boolean }): JSX.Element => {
  const { _t } = useTypedTranslation()
  const currentRoute = useLocation().pathname.substring(1)

  const getActiveMenuClass = (route: string) =>
    getActiveSubRouteClass([route], currentRoute, 'appbar-dropdown-item-selected')

  return (
    <AppbarDropdown
      className={getActiveSubRouteClass([DIGEST_ROUTE, AETHER_ROUTE], currentRoute, 'appbar-dropdown-selected')}
      title={_t('enterprise')}
    >
      {hasReward ? (
        <Link
          className={`dropdown-item ${getActiveMenuClass(DIGEST_ROUTE)}`}
          to={getPageUrl('reward-redirect') as string}
        >
          {_t('digest')}
        </Link>
      ) : null}
      <Link
        className={`dropdown-item ${getActiveMenuClass(AETHER_ROUTE)}`}
        to={getPageUrl('aether-upgrade') as string}
        onClick={() => trackEvent({ event: 'aether_upgrade_cta', cta_source: 'appbar-enterprise' })}
      >
        {_t('metadefender-aether')}
      </Link>
    </AppbarDropdown>
  )
}

export default Enterprise
